/**
 * Route for `customizable-alert-notification-template`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomizableAlertNotificationTemplatePage } from "../features/customizable-alert-notification-template/CustomizableAlertNotificationTemplatePage";

export const customizableAlertNotificationTemplateRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/customizable-alert-notification-template",
	component: CustomizableAlertNotificationTemplatePage,
});

export default customizableAlertNotificationTemplateRoute;
